import { MarshallReddickLogo } from '@/components/icons';
import { useEffect, useState } from 'react';

export const AccountCenterBox = ({
  children,
  title,
  description,
  isSubmitting = false,
}: {
  children: React.ReactNode;
  title?: string;
  description?: string;
  isSubmitting?: boolean;
}) => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    setShowOverlay(isSubmitting);
  }, [isSubmitting]);

  return (
    <div className="min-h-screen bg-main flex items-center justify-center">
      <div className="shadow-xl w-full max-w-[22.5rem] sm:max-w-[22.5rem] md:max-w-[44rem] lg:max-w-[46rem]">
        <div className="flex flex-col md:flex-row">
          {/* LEFT PANEL */}
          <div className="flex items-center justify-center md:w-[18rem] lg:w-[18rem] bg-primary h-48 sm:h-48 md:h-auto overflow-hidden">
            <div className="flex flex-col items-center gap-4">
              <div className="w-30 sm:w-30 md:w-45">
                <MarshallReddickLogo />
              </div>
              <p className="text-white">Marshall Reddick Real Estate</p>
            </div>
          </div>

          {/* RIGHT PANEL — FORM */}
          <div className="flex-1 py-8 md:py-16 px-6 md:px-12 lg:px-18 bg-offset relative">
            {title && <h1 className="text-title text-center text-2xl mb-6">{title}</h1>}
            {description && <p className="text-sm text-title-description mb-6">{description}</p>}
            {children}
            {showOverlay && (
              <div
                className="loading-overlay"
                role="status"
                aria-live="polite"
                aria-busy="true"
                aria-label="Form is submitting"
              >
                <span className="loading loading-spinner w-12 h-12 text-blue-500"></span>
                <span className="sr-only">Submitting form, please wait...</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
